import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import classNames from 'classnames'
import * as React from 'react'
import { Button } from 'react-bootstrap'

import Col from 'src/components/layout/Col'
import { screenSm, sm } from 'src/theme/variables'
import styles from './style.module.scss'

// const styles = () => ({
//   root: {
//     alignItems: 'center',
//     display: 'flex',
//     height: '100%',

//     [`@media (min-width: ${screenSm}px)`]: {
//       flexBasis: '280px',
//     },
//   },
//   provider: {
//     alignItems: 'center',
//     cursor: 'pointer',
//     display: 'flex',
//     flex: '1 1 auto',
//     padding: sm,
//     [`@media (min-width: ${screenSm}px)`]: {
//       paddingLeft: sm,
//       paddingRight: sm,
//     },
//   },
//   expand: {
//     height: '30px',
//     width: '30px',
//   },
// })

class Provider extends React.Component<any> {
  myRef

  constructor(props) {
    super(props)

    this.myRef = React.createRef()
  }

  render() {
    const { render, info, open, toggle } = this.props

    return (
      <>
        <div className={classNames(styles['network'])} ref={this.myRef}>
          <Button variant="shadow" className={classNames('btn-circle', styles['btn'])} onClick={toggle}>
            {info}
            <span className="ms-3">{open ? <ExpandLess /> : <ExpandMore />}</span>
          </Button>
        </div>
        {render(this.myRef)}
      </>
    )
  }
}

export default Provider
